export const getJob = (jobs, Job_id) => jobs.find(job => job.id === parseInt(Job_id));
